/**
 * Created by mac on 5/25/21
 */

const HeroItem = function (unit) { 
    UnitComponent.call(this, unit);

    if (this.isHero()) {
        Map2d.currentMap.addHero(this.unit);
    }
};

HeroItem.prototype = Object.create(UnitComponent.prototype);
HeroItem.prototype.constructor = HeroItem;

HeroItem.IsHero = function (unit) {
    const heroitem = unit.findComponent(HeroItem);
    return heroitem && heroitem.isHero();
};

HeroItem.IsOneOfTwoLastHeroItems = function (unit) {
    const heroitem = unit && unit.findComponent(HeroItem);
    return heroitem && !heroitem.isHero() && unit.stage >= Families[unit.code].units.length - 3;
};

HeroItem.IsFirstHeroItem = function (unit) {
    const heroitem = unit && unit.findComponent(HeroItem);
    return heroitem && unit.stage === 0;
};

HeroItem.prototype.isHero = function () {
    return this.unit.stage === Families[this.unit.code].units.length - 1;
};

HeroItem.prototype.destructor = function () {
    if (this.isHero()) {
        Map2d.currentMap.removeHero(this.unit);
    }
};

HeroItem.prototype.getActionInfo = function () {
    if (cleverapps.focusManager.isFocused() || cleverapps.gameLevel.getLevel() < 3 || this.isHero()) {
        return undefined;
    }
    return {
        title: cleverapps.unitsLibrary.getUnitName(this.unit),
        windowParameters: {
            unitsLibrary: true,
            unit: this.unit
        }
    };
};